import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

console.log(
  '%c✦ StellarFM %c— LE SON DE MAINTENANT',
  'background:#7c3aed;color:#fff;font-weight:800;font-size:14px;padding:6px 12px;border-radius:6px 0 0 6px;',
  'background:#1e1b4b;color:#a78bfa;font-size:14px;padding:6px 12px;border-radius:0 6px 6px 0;'
)
console.log(
  '%cTu fouilles dans les sources ? On recrute 👀',
  'color:#a78bfa;font-size:11px;'
)
console.log(
  '%chttps://recrutements.stellarfm.fr/',
  'color:#6d28d9;font-size:11px;text-decoration:underline;'
)

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
